module.exports = __webpack_public_path__ + "img/2.15a64b84.jpg";